















import { Component, Vue } from 'vue-property-decorator';
import { curPref } from '@/services/Preferences';
import NavBar from '@/components/NavBar.vue';
import EnterpriseList from '@/components/admin/EnterpriseList.vue';
import EnrolProfileList from '@/components/admin/EnrolProfileList.vue';

import moment from 'moment';

@Component({
  components: {
    NavBar,
    EnterpriseList,
    EnrolProfileList
  },
})

export default class Admin extends Vue {
  
  curSection:string = curPref.retrieve('noc-admin-cur-section', 'enterprises');

  mounted() {
    // todo
  }

  navbarClickHandler(newSection:string) {
    curPref.store('noc-admin-cur-section', newSection);
    this.curSection = newSection;
  }

}
